// extracted by mini-css-extract-plugin
module.exports = {"container":"Sm-z","disabled":"Tm-z","bgBlack":"Um-z","content":"Vm-z","countdown":"Wm-z","topCaption":"Xm-z","topHeading":"Ym-z","heading":"Zm-z","copy":"_m-z"};